import { color } from 'framer-motion';
import React, { useEffect, useRef, useState } from 'react';

function ServicesShowcase  ()  {
  const [isVisible, setIsVisible] = useState(false);
  const componentRef = useRef(null);

  const styles = {
    container: {
      position: 'relative',
      minHeight: '100vh',
      backgroundColor: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      color: 'white',
    },
    headerContainer: {
      textAlign: 'center',
      marginBottom: '3rem',
      transform: isVisible ? 'translateY(0)' : 'translateY(-20px)',
      opacity: isVisible ? '1' : '0',
      transition: 'all 1s ease',
    },
    subheading: {
        display: 'inline-block',
        padding:  '8px 20px',
        backgroundColor: 'white',
        borderRadius: '30px',
        marginBottom: '16px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
        color: '#400684',
        fontWeight: '600',
        fontSize: '14px' 
    },
    heading: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      color:'#400684',
      marginBottom: '-2rem',
    },
    servicesWrapper: {
      position: 'relative',
      width: '100%',
      maxWidth: '1200px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
    },
    serviceColumn: {
      width: '100%',
      maxWidth: '400px',
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
      color:'black',
      padding: '0 1rem',
      '@media (min-width: 768px)': {
        width: '33.333333%',
      },
    },
    serviceItem: (index, isLeft) => ({
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'white',
      borderRadius: '8px',
      color:'black',
      padding: '1rem',
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
      transform: isVisible 
        ? 'translateX(0)' 
        : `translateX(${isLeft ? '-50px' : '50px'})`,
      opacity: isVisible ? '1' : '0',
      transition: 'all 1s ease',
      transitionDelay: `${index * 200}ms`,
    }),
    checkmark: {
      width: '24px',
      height: '24px',
      marginRight: '12px',
      backgroundColor: '#400684',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '14px',
    },
    serviceText: {
      fontSize: '1rem',
      color:'black',
    },
    imageContainer: {
      width: '100%',
      maxWidth: '400px',
      padding: '2rem',
    //   marginTop:'-70px',
      '@media (min-width: 768px)': {
        width: '33.333333%',
      },
    },
    imageWrapper: {
      width: '256px',
      height: '256px',
      margin: '0 auto',
      borderTopLeftRadius: '9999px',
      borderTopRightRadius: '9999px',
      overflow: 'hidden',
      transform: isVisible ? 'scale(1)' : 'scale(0.95)',
      opacity: isVisible ? '1' : '0',
      transition: 'all 1s ease',
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.2 }
    );

    if (componentRef.current) {
      observer.observe(componentRef.current);
    }

    return () => {
      if (componentRef.current) {
        observer.unobserve(componentRef.current);
      }
    };
  }, []);

  const services = [
    { id: 1, text: "Security Solution Services" },
    { id: 2, text: "Office Productivity Tools Support" },
    { id: 3, text: "SharePoint Services" },
    { id: 4, text: "Azure Cloud Solutions" },
    { id: 5, text: "Active Directory Management" },
    { id: 6, text: "MS Exchange & Hyper-V Support" }
  ];

  return (
    <div ref={componentRef} style={styles.container}>
      <div style={styles.headerContainer}>
        <p style={styles.subheading}>★ SERVICES ★</p>
        <h2 style={styles.heading}>
        Customer Service That Grows
        </h2>
      </div>

      <div style={styles.servicesWrapper}>
        <div style={styles.serviceColumn}>
          {services.slice(0, 3).map((service, index) => (
            <div key={service.id} style={styles.serviceItem(index, true)}>
              <div style={styles.checkmark}>✓</div>
              <span style={styles.serviceText}>{service.text}</span>
            </div>
          ))}
        </div>

        <div style={styles.imageContainer}>
          <div style={styles.imageWrapper}>
            <img
              src="/microsoft.png"
              alt="Customer Service Representative"
              style={styles.image}
            />
          </div>
        </div>

        <div style={styles.serviceColumn}>
          {services.slice(3).map((service, index) => (
            <div key={service.id} style={styles.serviceItem(index, false)}>
              <div style={styles.checkmark}>✓</div>
              <span style={styles.serviceText}>{service.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesShowcase;